import React from 'react';
import PropTypes from 'prop-types';
import withAuth from '../App/Authenticate';
import { withRouter } from 'found';
import MobileHeader from '../App/MobileHeader';
import { Grid, Menu, Icon, Item } from 'semantic-ui-react';
import { AvailabilityChecker } from '../Modules';

const FinancialComponent = class FinancialComponent extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    location: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    sidebarOpen: PropTypes.bool,
    toggleSidebar: PropTypes.func.isRequired,
    viewer: PropTypes.object.isRequired
  };

  render() {
    const {
      children,
      location,
      router,
      sidebarOpen,
      toggleSidebar,
      viewer
    } = this.props;

    return (
      <div>
        <MobileHeader viewer={viewer} router={router}>
          <div className='menu'>
            <Item
              as='a'
              className={sidebarOpen ? 'active ' : ''}
              onClick={toggleSidebar}
            >
              <Icon name='sidebar' />
            </Item>
          </div>
          <div className='right menu'>
            <AvailabilityChecker viewer={viewer} mobile />
            <Item as='a' onClick={router.push.bind(null, '/search')}>
              <Icon name='search' />
            </Item>
          </div>
        </MobileHeader>
        <Grid container stackable>
          <Grid.Row rows='equal' style={{ marginTop: '2em' }}>
            <Grid.Column>
              <Menu secondary pointing>
                <Menu.Item
                  name='Overview'
                  active={router.isActive(
                    {
                      location: {
                        pathname: '/financials'
                      }
                    },
                    location,
                    { exact: true }
                  )}
                  onClick={() => router.push('/financials')}
                />
                <Menu.Item
                  name='Invoices'
                  onClick={() => router.push('/financials/invoices')}
                  active={location.pathname === '/financials/invoices'}
                />
                <Menu.Item
                  name='Payments'
                  onClick={() => router.push('/financials/payments')}
                  active={
                    router.isActive(
                      {
                        location: {
                          pathname: '/financials/payments'
                        }
                      },
                      location,
                      { exact: true }
                    ) ||
                    router.isActive(
                      {
                        location: {
                          pathname: '/financials/payments/outstanding'
                        }
                      },
                      location,
                      { exact: true }
                    ) ||
                    router.isActive(
                      {
                        location: {
                          pathname: '/financials/payments/refunds'
                        }
                      },
                      location,
                      { exact: true }
                    )
                  }
                />
              </Menu>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ margin: '2em 0' }}>
            <Grid.Column width={16}>
              {children}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
};

export default withRouter(withAuth(FinancialComponent));



// WEBPACK FOOTER //
// ./webpack/components/Financial/FinancialComponent.js